import {$, w} from './constants';

// UTM - Agregar y concatenar parámetros de la URL actual al enlace al hacer clic
/*
Ejemplo:
- URL actual en el navegador: 
  https://gbm.com?utm_source=facebook&utm_term=promocion

- Botón HTML:
  <a href="https://gbm.com?utm_campaign=verano" 
     id="advisors_me-interesa_form" 
     data-utm-medium="advisors_click">

- Resultado final al hacer clic:
  https://gbm.com?utm_campaign=verano
    &utm_source=sitio-web
    &utm_term=promocion
    &utm_medium=advisors_click_advisors_me-interesa_form
    &campana_fuente=trafico-directo
    &origen_candidato=perfilador

Notas:
- Los parámetros de la URL actual del navegador se agregan si no están presentes en el enlace.
- Se añaden parámetros adicionales definidos en el script si no están en el enlace original.
- El valor de `utm_medium` se construye así: `[data-utm-medium] + '_' + [id del botón]`.
- El comportamiento de redirección respeta el atributo `target` del enlace (`_blank` o mismo tab).
*/
$('a[data-utm-medium]').on('click', function (e) {
    e.preventDefault();
    

    const $this = $(this);
    const href = $this.attr('href');
    const originalUrl = new URL(href, window.location.origin);
    const target = $this.attr('target');

    // Obtener los parámetros actuales de la URL del navegador
    const currentParams = new URLSearchParams(window.location.search);

    // Obtener los parámetros que ya tiene el enlace de destino
    const linkParams = new URLSearchParams(originalUrl.search);

    // Obtener ID actual del botón (puede haber cambiado dinámicamente con updateButtonLink)
    const currentId = $this.attr('id') || '';

    // Valor base de utm_medium desde el atributo data
    const baseMedium = $this.data('utm-medium');

    // Concatenar _[id] si hay ID disponible
    const utmMediumFinal = currentId ? `${baseMedium}_${currentId}` : baseMedium;

    // Parámetros adicionales
    const additionalParams = {
        'utm_source': 'sitio-web',
        'utm_medium': utmMediumFinal,
        'campana_fuente': 'trafico-directo',
        'utm_campaign': 'trafico-directo',
        'origen_candidato': 'perfilador'
    };

    // Agregar los parámetros de la URL actual si no están en la URL del enlace
    currentParams.forEach((value, key) => {
        if (!linkParams.has(key)) {
            linkParams.set(key, value);
        }
    });

    // Agregar los parámetros adicionales si no existen
    for (const [key, value] of Object.entries(additionalParams)) {
        if (!linkParams.has(key) && value) {
            linkParams.set(key, value);
        }
    }

    // Reconstruir la URL final
    originalUrl.search = linkParams.toString();

    // Redirigir respetando el target (_blank o misma pestaña)
    if (target === '_blank') {
        window.open(originalUrl.toString(), '_blank');
    } else {
        window.location.href = originalUrl.toString();
    }
});